import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function tilesSlider () {

	// Skip containers already initialised (eg. re-running after an ACF
	// block preview refresh in the editor - see hook below)
	const swipers = document.querySelectorAll('section.tiles-slider .swiper:not(.swiper-initialized)');

	if (! swipers.length) return;



	// Init swiper
	swipers.forEach(function (container) {

		const section = container.closest('section');

		const layout = container.closest('.swiper-wrap').dataset.layout;

		if (layout === 'two') {

			new Swiper (container, {
				modules: [Navigation, Pagination],
				loop: false,
				spaceBetween: 24,
				breakpoints: {
					0:    { slidesPerView: 1 },
					540:  { slidesPerView: 1 },
					768:  { slidesPerView: 1.5 },
					1024: { slidesPerView: 2 },
					1364: { slidesPerView: 2 },
				},
				pagination: {
					el: section.querySelector('.swiper-pagination'),
					type: 'progressbar',
				},
				navigation: {
					prevEl: section.querySelector('.swipe-prev'),
					nextEl: section.querySelector('.swipe-next'),
				},
			});

		} else {

			new Swiper (container, {
				modules: [Navigation, Pagination],
				loop: false,
				/*
					Fractional slidesPerView (2.4 at 1364+, partial slide peeking
					on the right) would otherwise clamp the last position so the
					wrapper's right edge is flush with the container's right edge,
					breaking the grid rhythm - snapToSlideEdge fixes this (see
					cta-service.js for the same fix on its own fractional swiper).
				*/
				snapToSlideEdge: true,
				spaceBetween: 24,
				breakpoints: {
					0:    { slidesPerView: 1 },
					540:  { slidesPerView: 1 },
					768:  { slidesPerView: 1.5 },
					1024: { slidesPerView: 2 },
					1364: { slidesPerView: 2.4 },
				},
				pagination: {
					el: section.querySelector('.swiper-pagination'),
					type: 'progressbar',
				},
				navigation: {
					prevEl: section.querySelector('.swipe-prev'),
					nextEl: section.querySelector('.swipe-next'),
				},
			});

		}

	});

}



/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on attribute change) without a page reload, so
	'DOMContentLoaded' only covers the first render - re-run init on every
	preview refresh too. ACF's block-preview JS may run in the iframe's own
	window or in the parent admin window depending on context, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=tiles-slider', tilesSlider);
}
